import React, { useEffect, useState } from "react";
import "./naspop.css";
import { FaFolder, FaFile, FaAngleDown, FaAngleUp } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import { Button } from "reactstrap";
import vcdms from "../../../assets/rcc-version-logo.png";
function NasPop({
  showPicker,
  files,
  selectedFiles,
  handleSelectFile,
  handleNASSubmit,
  setShowPicker,
}) {
  const NasUser = localStorage.getItem("customerId");
  const [folderStructure, setFolderStructure] = useState([])
  const [openFolderName, setOpenFolderName] = useState('')
  const userRole = localStorage.getItem("CloudUserType")

  function organizeFilesByFolder(files) {
    const structure = [];
    files.forEach(file => {
      const path = file.name.split('/').filter(Boolean).slice(userRole === "property_user" ? 2 : 1);
      const name = path[0];
      const isFolder = path.length > 1;

      const existing = structure.find(item => item.name === name);

      if (isFolder) {
        if (existing) {
          existing.fileCount++;
          existing.size += file.size;
        } else {
          structure.push({ name, type: 'folder', size: file.size, fileCount: 1 });
        }
      } else {
        structure.push({ name, type: 'files', size: file.size });
      }
    });
    console.log(333, structure)
    setFolderStructure(structure)
  }

  const FilesRow = ({ file, index }) => {
    const isFolder = file?.type === 'folder';
    const isOpen = openFolderName === file.name;
    const [folderFiles, setFolderFiles] = useState([])
    useEffect(() => {
      if (isFolder) {
        const tempFolderfiles = files.filter(ele => ele.name.includes(file.name))
        setFolderFiles(tempFolderfiles.map(ele => ({ ...ele, folderName: file.name, type: "files", name: ele.name.split('/').at(-1) })))
      }
    }, [])
    return <>
      <div
        className="rowpic"
        key={index}
        style={{ borderBottomStyle: "solid" }}
      >
        {isFolder && <span onClick={() => toggleFolder(file.name)} style={{ cursor: 'pointer' }}>
          {isOpen ? <FaAngleUp /> : <FaAngleDown />}
        </span>}
        {file.type === "files" && <input
          className="checkboxnas"
          type="checkbox"
          checked={!!selectedFiles[file.folderName ? `${file.folderName}/${file.name}` : file.name]}
          onChange={() => handleSelectFile(file.folderName ? `${file.folderName}/${file.name}` : file.name)}
          style={{ marginLeft: file.folderName ? 16 : 0 }}
        />}

        {"   "}
        {file.type === "folder" ? <FaFolder /> : <FaFile />} {file.name} - (
        {(file.size / 1000000).toFixed(2)}mb)
      </div>
      {(isOpen && folderFiles.length > 0) &&
        folderFiles.map(ele => <FilesRow file={ele} />)}
    </>
  }

  const toggleFolder = (folderName) => {
    if (folderName === openFolderName)
      setOpenFolderName('')
    else
      setOpenFolderName(folderName)

  };

  useEffect(() => {
    if (files?.length)
      organizeFilesByFolder(files)
  }, [files])

  console.log(selectedFiles, "selectedFiles");
  return (
    <div>
      <Modal show={showPicker} onHide={() => setShowPicker(false)}>
        <div className="file-picker">
          <div className="popup">
            <div className="sidebarpic">
              <div className="logopic">
                <figure className="rcc-version-logo-for-picker">
                  <img src={vcdms} alt="rsd cloud portal img" />
                </figure>
                <h1>Pick File using RCC Cloud</h1>
              </div>
              {/* <div style={{ width: "100%" }}>
                <div
                  style={{
                    width: "100%",
                    backgroundColor: "#EBE8DB",
                    cursor: "pointer",
                    borderRadius: 10,
                    border: "2px dashed black",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 8,
                    padding: "9px 10px",
                  }}
                  onClick={openImportfiles}
                >
                  <LuImport size={30} />
                  <p style={{ fontSize: 17 }}>Import Files</p>
                </div>
              </div> */}

              <div className="footerpic">
                <hr></hr>
                <h4>RCC Cloud User :-</h4>
                <p>{NasUser}</p>
              </div>
            </div>
            <div>
              <Modal.Header closeButton>
                <Modal.Title>
                  {/* {onClickAddAndEditMsg} */}
                  Select Files
                </Modal.Title>
              </Modal.Header>
              <div className="selectlist">
                <section className="section">
                  {folderStructure?.map((file, index) => (
                    <FilesRow file={file} index={index} />
                  ))}
                </section>
              </div>
              <br />
              {/* <button onClick={handleDeselectAll}>Deselect All</button> */}
              <div>
                <Modal.Footer>
                  <Button color="danger" onClick={() => setShowPicker(false)}>
                    Close Picker
                  </Button>

                  <Button color="primary" onClick={handleNASSubmit}>
                    Submit
                  </Button>
                </Modal.Footer>
                {/* <button color="primary" onClick={handleNASSubmit}>Submit</button> */}
                {/* <button color="danger" onClick={() => setShowPicker(false)}>Close Picker</button> */}
              </div>
            </div>
          </div>
          {/* <Modal
            show={modalImportopen}
            onHide={uploadingLoader ? null : toggleModal}
          >
            <Modal.Header
              closeButton={!uploadingLoader}
              onHide={uploadingLoader ? null : toggleModal}
            >
              <Modal.Title>
                <strong>Import Files</strong>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ImportMediaDialog
                onClose={toggleModal}
                setShowPicker={setShowPicker}
                setUploadingLoader={setUploadingLoader}
              />
            </Modal.Body>
          </Modal> */}
        </div>
      </Modal>
    </div>
  );
}
export default NasPop;
